import { useNavigate } from 'react-router-dom';
import { useCompare } from '@/context/CompareContext';

const CompareBar = () => {
  const { compareList, removeFromCompare, clearCompare } = useCompare();
  const navigate = useNavigate();

  if (compareList.length === 0) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-stone-900 border-t border-stone-700 shadow-2xl">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-3 flex items-center gap-4 flex-wrap">
        {/* Label */}
        <div className="flex items-center gap-2 text-white text-sm font-semibold whitespace-nowrap">
          <div className="w-6 h-6 flex items-center justify-center bg-amber-500 rounded-full">
            <i className="ri-scales-line text-xs text-white"></i>
          </div>
          Compare ({compareList.length}/3)
        </div>

        {/* Property Slots */}
        <div className="flex items-center gap-3 flex-1 flex-wrap">
          {compareList.map(property => (
            <div
              key={property.id}
              className="flex items-center gap-2 bg-stone-800 rounded-lg px-3 py-1.5 group"
            >
              <div className="w-8 h-8 rounded-md overflow-hidden flex-shrink-0">
                <img
                  src={property.image}
                  alt={property.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <span className="text-white text-xs font-medium max-w-[140px] truncate">{property.title}</span>
              <button
                onClick={() => removeFromCompare(property.id)}
                className="w-4 h-4 flex items-center justify-center text-stone-400 hover:text-white transition-colors cursor-pointer ml-1"
              >
                <i className="ri-close-line text-sm"></i>
              </button>
            </div>
          ))}

          {/* Empty Slots */}
          {Array.from({ length: 3 - compareList.length }).map((_, i) => (
            <div
              key={`empty-${i}`}
              className="flex items-center gap-2 bg-stone-800/50 border border-dashed border-stone-600 rounded-lg px-3 py-1.5"
            >
              <div className="w-8 h-8 rounded-md bg-stone-700 flex items-center justify-center">
                <i className="ri-add-line text-stone-500 text-sm"></i>
              </div>
              <span className="text-stone-500 text-xs">Add property</span>
            </div>
          ))}
        </div>

        {/* Actions */}
        <div className="flex items-center gap-2 flex-shrink-0">
          <button
            onClick={clearCompare}
            className="px-3 py-1.5 text-stone-400 hover:text-white text-xs transition-colors cursor-pointer whitespace-nowrap"
          >
            Clear all
          </button>
          <button
            onClick={() => navigate('/compare')}
            disabled={compareList.length < 2}
            className="px-4 py-2 bg-amber-500 hover:bg-amber-400 disabled:bg-stone-600 disabled:cursor-not-allowed text-white text-sm font-semibold rounded-lg transition-colors cursor-pointer whitespace-nowrap"
          >
            Compare Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default CompareBar;
